import { Link } from 'react-router-dom';

export default function ServicesHero() {
  return (
    <section className="relative bg-gradient-to-b from-primary-900 via-primary-800 to-primary-900 pt-28 md:pt-36 pb-16 md:pb-20 px-6 md:px-12 lg:px-20">
      <div className="max-w-[1280px] mx-auto">
        <div className="inline-flex items-center gap-2 mb-8">
          <span className="text-accent-400 text-sm tracking-[0.2em] font-sans font-light">/</span>
          <span className="text-accent-400/80 text-xs md:text-sm tracking-[0.15em] font-sans font-light">事業紹介</span>
        </div>

        <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-light text-white tracking-[0.06em] leading-[1.35] max-w-2xl">
          リアルタイム・
          <br />
          リスク・エンジン
        </h2>

        <div className="mt-6 md:mt-8 space-y-4 text-sm md:text-base text-foreground-200/80 tracking-[0.06em] leading-[1.9] font-sans font-light max-w-xl">
          <p>
            AIとビッグデータを活用した銀行カード不正利用検知サービス。ディープラーニングによる異常検知アルゴリズムが、取引データをリアルタイムで分析し、不正の兆候を瞬時に特定します。
          </p>
          <p>
            金融庁ガイドラインに完全準拠。国内主要金融機関での導入実績を持ち、24時間365日の監視体制でお客様のビジネスを守ります。
          </p>
        </div>
      </div>
    </section>
  );
}